import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { useAuth } from '@crehana/auth';
import LogOut from '@crehana/compass.icons.outline/LogOut';
import { clsx } from 'clsx';
import useProfileUITranslations from "../i18n/useProfileUITranslations";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LogoutButton = function LogoutButton(_ref) {
  var isSupplanting = _ref.isSupplanting;
  var _useAuth = useAuth(),
    logout = _useAuth.logout;
  var _useProfileUITranslat = useProfileUITranslations(),
    t = _useProfileUITranslat.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var textColor = 'dark:tw-text-neutral-dark-500 tw-text-neutral-light-700';
  var hoveredColor = 'dark:hover:tw-text-secondary-light-500 hover:tw-text-primary-light-500';
  var text = isHovered ? hoveredColor : textColor;
  var bgColor = 'dark:tw-bg-neutral-dark-700 tw-bg-neutral-light-200';
  return /*#__PURE__*/_jsx("div", {
    className: clsx('tw-w-full tw-pt-2', !isSupplanting && 'tw-mt-2 tw-border-solid tw-border-t dark:tw-border-t-neutral-dark-700 tw-border-t-neutral-light-300'),
    children: /*#__PURE__*/_jsxs("button", {
      type: "button",
      onClick: logout,
      className: clsx('tw-w-full tw-flex tw-items-center tw-py-0.8 tw-px-0.8 tw-rounded-0.8  dark:tw-text-neutral-dark-500 tw-text-neutral-light-700 dark:hover:tw-text-secondary-light-500 hover:tw-text-primary-light-500', isHovered && bgColor),
      onMouseOver: function onMouseOver() {
        return setIsHovered(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setIsHovered(false);
      },
      onFocus: function onFocus() {
        // Empty function to fix eslint warning
      },
      children: [/*#__PURE__*/_jsx(LogOut, {
        size: 20,
        className: text
      }), /*#__PURE__*/_jsx("p", {
        className: "".concat(text, " tw-font-subtitle5 tw-ml-0.8"),
        children: t('PROFILE_LOGOUT')
      })]
    })
  });
};
export default LogoutButton;